import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { ProductDetailAddonsAddonSection } from './product-detail-addons-addon-section';
import { ProductDetailAddonsAmountItem } from './product-detail-addons-amount-item';
import { ProductDetailAddonsCategories } from './product-detail-addons-categories';
import './product-detail.scss';

type Props = ComponentPropsWithoutRef<'div'>;
const ProductDetailAddonsWrapper = ({ children, className, ...props }: Props) => {
    return (
        <div className={cn('product-detail__addons-wrapper', className)} {...props}>
            {children}
        </div>
    );
};

export const ProductDetailAddons = Object.assign(ProductDetailAddonsWrapper, {
    Categories: ProductDetailAddonsCategories,
    AddonSection: ProductDetailAddonsAddonSection,
    AmountItem: ProductDetailAddonsAmountItem,
});
